import { getOpenGraphUrl, getPageSeoBreadcrumbs } from './SeoHelpers';

import type { PageSeoProps, TFunction } from 'types';

export function getAboutPageSeo(t: TFunction, isMobilePreview?: boolean): PageSeoProps {
  return {
    seoProps: {
      openGraph: {
        url: getOpenGraphUrl(),
      },
      noindex: !!isMobilePreview
    },
    breadcrumbs: getPageSeoBreadcrumbs(t)
  };
}
